import { flexRender, Header } from '@tanstack/react-table';
import { Checkbox } from '../../../../Checkbox';
import { ColumnFilter, EnumFilterType } from '../../../types';
import { FilterContainer, FilterLabel, OptionList, OptionListItem, OptionListItemLabel } from '../styles';

interface TableColumnMultiSelectFilterProps<T> {
    header: Header<T, unknown>;
    setColumnFilter: (value?: ColumnFilter) => void;
    selectedOptions: string[];
}

const TableColumnMultiSelectFilter = <T,>({
    header,
    setColumnFilter,
    selectedOptions,
}: TableColumnMultiSelectFilterProps<T>) => {
    const handleChange = (value: string) => {
        const nextOptions = selectedOptions.includes(value)
            ? selectedOptions.filter((option) => option !== value)
            : [...selectedOptions, value];

        setColumnFilter(
            nextOptions.length
                ? {
                      filterType: EnumFilterType.In,
                      value: nextOptions,
                  }
                : undefined
        );
    };

    const { meta, header: columnHeading } = header.column.columnDef;

    return (
        <FilterContainer vertical spacing="100">
            {meta?.showHeaderInColumnFilter ? (
                <FilterLabel>{flexRender(columnHeading, header.getContext())}</FilterLabel>
            ) : null}
            <OptionList>
                {meta?.getMultiSelectOptions &&
                    meta.getMultiSelectOptions().map(({ label, value }, index, options) => (
                        <OptionListItem
                            key={`${header.column.id}-${value}`}
                            active={selectedOptions.includes(value)}
                            nextIsSelected={selectedOptions.includes(options[index + 1]?.value)}
                            previousIsSelected={selectedOptions.includes(options[index - 1]?.value)}
                        >
                            <Checkbox
                                checked={selectedOptions.includes(value)}
                                onChange={() => handleChange(value)}
                                name={`${header.column.id}-${value}`}
                                size="small"
                            >
                                <OptionListItemLabel>{label}</OptionListItemLabel>
                            </Checkbox>
                        </OptionListItem>
                    ))}
            </OptionList>
        </FilterContainer>
    );
};

export default TableColumnMultiSelectFilter;
